import React from "react";

const SchoolContext = React.createContext()

export default SchoolContext;